// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"LoadingScreen-module__loadingScreen___TJHLs","loadingScreenDesktop":"LoadingScreen-module__loadingScreenDesktop___TFh4f"};